export default function(text,target,callback){
    const targetEl = document.querySelector(target);
    const tpl = `<div id="menu-container">
<button class="koa-menu-btn">Zur Stimmenverteilung</button></div>`
    targetEl.innerHTML = tpl;
    const btn = targetEl.querySelector('button');

    btn.addEventListener('click', ()=>{
        btn.innerText = btn.toggle ? 'Zur Stimmenverteilung': 'Zum Koalitionsrechner';
        callback(btn.toggle);
        btn.toggle = !btn.toggle;
    });
}
